import { PropsWithChildren } from 'react'

const DevOnly = (props: PropsWithChildren) => {
  const visible = import.meta.env.VITE_REACT_HIDE_DEV !== '1'

  return visible && props.children
}

export default DevOnly
